<template>
  <section>
    <div class="dicom-plus-container">
      <section class="dicom-plus">
        <x-plus-tab />
      </section>
    </div>
  </section>
</template>

<script>
import XPlusTab from './x-plus-tab/index.vue'

export default {
  name: 'x-plus-page',
  components: { XPlusTab }
}
</script>

<style scoped>
.dicom-plus-container {
  width: 92%;
  margin: 60px auto 55px auto;
  color: #757575;
  overflow-x: auto;
}

@media (max-width: 720px) {
  .dicom-plus-container {
    width: calc(100% - 18px);
    margin: 56px auto 24px auto;
    overflow-x: hidden;
  }
}
</style>
